__turbopack_context__.v({
  "accent": "company-culture-module__KSMQkq__accent",
  "button": "company-culture-module__KSMQkq__button",
  "container": "company-culture-module__KSMQkq__container",
  "content": "company-culture-module__KSMQkq__content",
  "description": "company-culture-module__KSMQkq__description",
  "header": "company-culture-module__KSMQkq__header",
  "image": "company-culture-module__KSMQkq__image",
  "imageWrapper": "company-culture-module__KSMQkq__imageWrapper",
  "imagesGrid": "company-culture-module__KSMQkq__imagesGrid",
  "section": "company-culture-module__KSMQkq__section",
  "statCard": "company-culture-module__KSMQkq__statCard",
  "statCardContent": "company-culture-module__KSMQkq__statCardContent",
  "statCardHeader": "company-culture-module__KSMQkq__statCardHeader",
  "statGlow": "company-culture-module__KSMQkq__statGlow",
  "statLabel": "company-culture-module__KSMQkq__statLabel",
  "statSuffix": "company-culture-module__KSMQkq__statSuffix",
  "statValue": "company-culture-module__KSMQkq__statValue",
  "statsGrid": "company-culture-module__KSMQkq__statsGrid",
  "title": "company-culture-module__KSMQkq__title",
});
